import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { FRAGMENT_CARD_PADDING_X } from '../constants';

/**
 * Wrapper for content anchored at the bottom-right of a fragment card media area
 * (e.g. duration pill). Uses absolute positioning and shared padding so overlays align.
 */
export function FragmentCardMediaBottomRightItem({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        px: FRAGMENT_CARD_PADDING_X.xs,
        py: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 1,
      }}
    >
      {children}
    </Box>
  );
}
